import { createSelector } from '@reduxjs/toolkit';

import { ADVISER, MANAGER } from '../utils/userRoles';

const selectTeamsForLoggedInUserEntries = (state) =>
    state.entities.userService.teamsForLoggedInUser;
const selectUserTypeEntries = (state) => state.entities.userService.userTypes;
const selectLoggedInUserEntry = (state) => state.entities.userService.loggedInUser;
const selectUserEntries = (state) => state.entities.userService.users;

const selectUsersByLoggedInUserServiceIdsEntries = (state) =>
    state.entities.userService.usersByLoggedInUserServiceIds;
const selectUsersMinimalDetailEntries = (state) => state.entities.userService.usersMinimalDetails;

export const selectUserTypes = createSelector(selectUserTypeEntries, (userTypes) => userTypes);

export const selectAdviserTypeIds = createSelector(selectUserTypeEntries, (userTypes) =>
    userTypes.filter((el) => el.role === MANAGER || el.role === ADVISER).map((el) => el.id)
);

export const selectLoggedInUser = createSelector(
    selectLoggedInUserEntry,
    (loggedInUser) => loggedInUser
);

export const selectUserRoles = createSelector(
    selectLoggedInUser,
    (loggedInUser) => loggedInUser.roles
);

export const selectUsers = createSelector(selectUserEntries, (users) => users);

export const selectUsersForNames = createSelector(
    selectUsersByLoggedInUserServiceIdsEntries,
    selectUsersMinimalDetailEntries,
    selectUserEntries,
    (usersByLoggedInUserServiceIds, usersMinimalDetails, users) => [
        ...usersByLoggedInUserServiceIds,
        ...usersMinimalDetails,
        ...users
    ]
);

export const selectUsersForNamesById = createSelector(selectUsersForNames, (usersForNames) =>
    usersForNames.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {})
);

export const selectUser = () =>
    createSelector(
        selectUserEntries,
        (_, id) => id,
        (users, id) => users.find((el) => el.id === id) || {}
    );

export const selectUserName = () =>
    createSelector(
        selectUserEntries,
        (_, id) => id,
        (users, id) => {
            const user = users.find((el) => el.id === id);
            return user ? `${user.firstName} ${user.lastName}` : '';
        }
    );

export const selectAllUsersPrimaryServiceIds = createSelector(selectUserEntries, (users) => [
    ...new Set(users.map((el) => el.primaryService).filter((el) => el))
]);

export const selectLoggedInUserFirstAndLastName = createSelector(
    selectLoggedInUser,
    (loggedInUser) => {
        const { firstName, lastName } = loggedInUser;
        if (!firstName || !lastName) return '';
        return `${firstName} ${lastName}`;
    }
);

export const selectSortedTeamsForLoggedInUser = createSelector(
    selectTeamsForLoggedInUserEntries,
    (teamsForLoggedInUser) => {
        const newTeams = [...teamsForLoggedInUser];
        return newTeams.sort((a, b) => a.name.localeCompare(b.name));
    }
);
